const features = {
  nodaFiCheck: 'nodafi_check',
  survey: 'survey',
  externalOrganizations: 'external_organizations',
  insight: 'insight',
  procedures: 'procedures',
  purchaseOrders: 'purchase_orders',
  procedureFieldEntryComments: 'procedure_field_entry_comments',
  customViews: 'custom_views',
  issueCategoryHierarchy: 'issue_category_hierarchy',
  advancedInsights: 'advanced_insights',
} as const

export type FeatureGateName = (typeof features)[keyof typeof features]

export default features
